import { Record, Map } from 'immutable';
import {
  iphone,
  iphoneLandscape,
  ipad,
  ipadLandscape,
} from 'Shared/assets/images/';

export const MAX_WIDTH = 'maxWidth';
export const MAX_HEIGHT = 'maxHeight';
export const BOUNDS = 'bounds';
export const FIT_TO_SCREEN = 'fitToScreen';
export const CANVAS_SCALE = 'canvasScale';
export const CUSTOM_PREVIEW_ARTBOARDS_LOADED = 'customPreviewArtboardsLoaded';
export const DEVICE = 'device';
export const FRAME = 'frame';
export const NO_DEVICE = 'No device';
export const NAME = 'name';
export const TOP = 'top';
export const LEFT = 'left';
export const RIGHT = 'right';
export const BOTTOM = 'bottom';
export const IMAGE = 'image';
export const SCREEN = 'screen';
export const PORTRAIT = 'portrait';
export const LANDSCAPE = 'landscape';
export const DEVICE_ORIENTATION = 'deviceOrientation';
export const SELECTED_CONTAINER = 'selectedContainer';
export const SELECTED_LAYOUT = 'selectedLayout';
export const HEADLESS_PREVIEW = 'headlessPreview';

export const SRC = 'src';
export const DIMENSIONS = 'dimensions';
export const ORIENTATIONS = [PORTRAIT, LANDSCAPE];
export const CUSTOM_BACKGROUND_UPLOADING = 'customBackgroundUploading';

export const RESIZE_MULTIPLIER = 2;
export const BOUND_PADDING = 20;
export const ARTBOARD_NAME_HEIGHT = 30;
export const HANDLE_HEIGHT = 25;
export const SETTINGS_PANEL_WIDTH = 423;

export const SMALL_MOBILE_DEVICE_DIMENSIONS = [375, 667];
export const MEDIUM_MOBILE_DEVICE_DIMENSIONS = [390, 844];
export const LARGE_MOBILE_DEVICE_DIMENSIONS = [428, 926];

export const MOBILE_PORTRAIT_DEVICE_DIMENSIONS = [390, 844];
export const MOBILE_LANDSCAPE_DEVICE_DIMENSIONS = [390, 844];

export const TABLET_PORTRAIT_DEVICE_DIMENSIONS = [768, 1024];
export const TABLET_LANDSCAPE_DEVICE_DIMENSIONS = [1024, 768];

export const MOBILE_DEVICE_TOOLBAR_HEIGHT = 40;

export const Frame = new Record({
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
});

export const DEVICES = {
  iphone: Map({
    name: 'iPhone 5',
    portrait: new Map({
      src: iphone,
      image: new Map({
        width: 380,
        height: 796,
      }),
      screen: new Map({
        width: 320,
        height: 568,
      }),
      frame: new Frame({
        top: 118,
        bottom: 110,
        left: 32,
        right: 28,
      }),
    }),
    landscape: new Map({
      src: iphoneLandscape,
      image: new Map({
        width: 796,
        height: 380,
      }),
      screen: new Map({
        width: 568,
        height: 320,
      }),
      frame: new Frame({
        top: 28,
        bottom: 32,
        left: 118,
        right: 110,
      }),
    }),
  }),
  ipad: Map({
    name: 'iPad Air',
    portrait: new Map({
      src: ipad,
      image: new Map({
        width: 856.1,
        height: 1187,
      }),
      screen: new Map({
        width: 768,
        height: 1024,
      }),
      frame: new Frame({
        top: 81,
        bottom: 82,
        left: 45,
        right: 45,
      }),
    }),
    landscape: new Map({
      src: ipadLandscape,
      image: new Map({
        width: 1187,
        height: 856.1,
      }),
      screen: new Map({
        width: 1024,
        height: 768,
      }),
      frame: new Frame({
        top: 45,
        bottom: 45,
        left: 81,
        right: 82,
      }),
    }),
  }),
};



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Preview/constants/index.js